import React, {useEffect, useState} from 'react';
import { useSelector } from 'react-redux';
import {  useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import apiClient from '../../../../services/api';
import store from '../../../../store';
import {toggleMessageOpen} from '../../../../store/actions/Message';
import { createConfirmAction } from '../../../../store/actions/ConfirmDialog';
import { setProjectSort } from '../../../../store/actions/FilterView';
import StyledProjectList from '../../../partials/project/list/StyledProjectList';

export default function ProjectList()
{
    const { t } = useTranslation();
    const navigate = useNavigate();

    const [projects, setProjects] = useState([]);
    const [screenshots, setScreenshots] = useState([]);
    const [sortArray, setSortArray] = useState(null);
    const [loading, setLoading] = useState(false);
    const [screenshotsLoaded, setScreenshotsLoaded] = useState(false);
    const [projectsLoading, setProjectsLoading] = useState(false);
    const [height, setHeight] = useState(400);

    const isExpanded = useSelector((state) => state.filterView.projectListFilterOptionsExpanded);
    const projectListFilters = useSelector((state) => state.filterView.projectListFilters);
    const projectSort = useSelector((state) => state.filterView.projectSort);

    useEffect(() => {
        setLoading(true);

        apiClient.post('/api/modules/check', {name: 'easyBoardOnline'}).then(response => {
            if(!response.data.success) {
                store.dispatch(toggleMessageOpen(t("You don't have permission to enter this page"), "error"))

                navigate('/app/home');
            } else {
                setLoading(false);
            }
        })
    }, [])// eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        if(!projectListFilters || !projectSort || projectsLoading) {
            return;
        }

        setProjectsLoading(true);
        setProjects([]);

        apiClient.post(
            '/api/projects', 
            {
                filters: projectListFilters,
                sort: JSON.parse(projectSort)
            }
        ).then(response => {
            if(!response.data.success) {
                store.dispatch(toggleMessageOpen(t('An error occurred while selecting project'), "error"));
                return
            }

            setProjects(response.data.projects);
            setProjectsLoading(false);
        }).catch(error => {
            store.dispatch(toggleMessageOpen(t('An error occurred while selecting project'), "error"))
        });
    }, [projectListFilters, projectSort])// eslint-disable-line react-hooks/exhaustive-deps
   
    const handleDeleteClicked = (event, id) => {
        event.stopPropagation();

        store.dispatch(createConfirmAction(handleDelete, t('Are you sure?'), id));
    }

    const handleDelete = (id) => {
        apiClient.post('/api/projects/delete', {id: id, filters: projectListFilters, sort: JSON.parse(projectSort)}).then(response => {
            if(!response.data.success) {
                store.dispatch(toggleMessageOpen(t(response.data.message), "error"));

                return;
            }

            setProjects(response.data.projects)
        }).catch(error => {
            store.dispatch(toggleMessageOpen(t('An error occurred while deleting project'), "error"))
        });
    }

    const handleClick = (id) => {
        navigate('/app/project/view/'+id);
    }

    const sort = (attribute) => {
        const array = JSON.parse(projectSort);

        if(attribute === 'name') {
            array['date'] = null;

            if(!array['name']) {
                array['name'] = 'ASC';
            } else {
                array['name'] = array['name'] === 'ASC' ? 'DESC' : 'ASC';
            }
        } else {
            array['name'] = null;

            if(!array['date']) {
                array['date'] = 'ASC';
            } else {
                array['date'] = array['date'] === 'ASC' ? 'DESC' : 'ASC';
            }
        }

        store.dispatch(setProjectSort(JSON.stringify(array)));
        setSortArray(array);
    }

    return (
        <StyledProjectList
            height={height}
            setHeight={setHeight}
            handleDeleteClicked={handleDeleteClicked}
            handleClick={handleClick}
            isExpanded={isExpanded}
            sort={sort}
            sortArray={sortArray}
            projects={projects}
            title={t('Planograms')}
            type='planograms'
        />
    );
}